module.exports = __webpack_public_path__ + "img/LogoST.1550d111.svg";